import { render, staticRenderFns } from "./dbCompareListPage.vue?vue&type=template&id=9717b99c"
import script from "./dbCompareListPage.vue?vue&type=script&lang=js"
export * from "./dbCompareListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports